import styled from 'styled-components';
import { tokens } from 'design-tokens/warwick/tokens';

const { primitive } = tokens;

export const WeatherCard = styled.div`
  background-color: ${primitive.color.purple};
  border-radius: ${primitive.radius[21]};
  padding: ${primitive.space[28]};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 330px;

  > * + * {
    margin-top: ${primitive.space[28]} !important;
  }
`;

export const WeatherCityName = styled.h2`
  font-family: ${primitive.typography.fontFamily.base};
  font-size: ${primitive.typography.fontSize[20]};
  font-weight: ${primitive.typography.fontWeight.medium};
  line-height: ${primitive.typography.lineHeight.normal};
  color: ${primitive.color.white};
  margin: 0;
  text-align: center;
  word-break: break-word;
`;

export const WeatherIconBox = styled.div`
  width: ${primitive.space[109]};
  height: ${primitive.space[109]};
  background-color: ${primitive.color.gold};
  border-radius: ${primitive.radius[21]};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  > * {
    justify-content: center;
  }
`;

export const WeatherTemp = styled.p`
  font-family: ${primitive.typography.fontFamily.base};
  font-size: ${primitive.typography.fontSize[40]};
  font-weight: ${primitive.typography.fontWeight.semiBold};
  line-height: ${primitive.typography.lineHeight.tight};
  color: ${primitive.color.white};
  margin: 0;
`;

export const WeatherDetailsSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  > * + * {
    margin-top: ${primitive.space[13]};
  }
`;

export const WeatherDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const WeatherDetailLeft = styled.div`
  display: flex;
  align-items: center;

  > * + * {
    margin-inline-start: ${primitive.space[10]};
  }
`;

export const WeatherDetailIcon = styled.img`
  width: ${primitive.size.icon.sm};
  height: ${primitive.size.icon.sm};
`;

export const WeatherDetailLabel = styled.span`
  font-family: ${primitive.typography.fontFamily.base};
  font-size: ${primitive.typography.fontSize[16]};
  font-weight: ${primitive.typography.fontWeight.medium};
  line-height: ${primitive.typography.lineHeight.tight};
  color: ${primitive.color.white};
`;

export const WeatherDetailValue = styled.span`
  font-family: ${primitive.typography.fontFamily.base};
  font-size: ${primitive.typography.fontSize[18]};
  font-weight: ${primitive.typography.fontWeight.medium};
  line-height: ${primitive.typography.lineHeight.tight};
  color: ${primitive.color.gold};
`;
